export const inspectList = [
  {
    title: "청소",
    content: "작업자가 넘어지거나 미끄러지는 등의 위험이 없도록 바닥 등을 안전하고 청결하게 유지한다.",
    isChecked: "",
  },
  {
    title: "조도",
    content: "작업자가 작업하는 장소 및 통로에 알맞은 조도를 확보하고, 상시 통행을 하지 않는 곳에는 휴대용 조명기구를 사용하도록 관리한다.",
    isChecked: "",
  },
  {
    title: "통로",
    content: "작업자가 안전하게 이동할 수 있도록 공정 변화에 맞춰 사전에 통로 확보 방안을 검토하여 설치한다.",
    isChecked: "",
  },
  {
    title: "통로",
    content:
      "가설통로를 설치하는 경우에는 견고하고 미끄러지지 않게 설치하고, 설치상태를 수시로 점검한다.<br/>" +
      "      *가설통로 설치기준 : 견고한 구조, 경사는 30도 이하(계단을 설치하거나 높이 2미터 미만의 가설통로로서 손잡이 설치한 경우 제외), 경사가 15도를 초과하는 경우\n" +
      "       미끄러지지 아니하는 구조 등",
    isChecked: "",
  },
  {
    title: "통로",
    content: "사다리식 통로를 설치하는 경우 설치기준*에 맞게 설치하고, 설치상태를 수시로 점검한다.<br/>" + "       *사다리식 통로 설치기준 : 견고한 구조, 손상·부식 등이 없는 재료 사용, 사다리가 넘어지거나 미끄러짐 방지를 위한 조치 등",
    isChecked: "",
  },
  {
    title: "통로",
    content: "비상시 작업장 내에서 탈출할 수 있는 비상구가 적절히 마련되어 있으며, 비상구 표시가 작업자 눈에 띄기 쉬운 곳에 부착되어 있다.",
    isChecked: "",
  },
  {
    title: "통로",
    content: "비상구·비상통로 또는 비상용 기구를 쉽게 이용할 수 있도록 유지하고, 연면적 400제곱미터 이상 또는 상시 50명 이상 작업하는 옥내작업장의 경우 비상시 신속하게\n" + "       알리기 위한 경보용 설비·기구가 설치되어 있다.",
    isChecked: "",
  },
  {
    title: "보호구",
    content: "작업조건에 맞는 보호구를 지급하고, 착용여부를 수시로 점검한다.",
    isChecked: "",
  },
  {
    title: "보건관리",
    content: "열사병, 한랭질환 등 건설현장 작업자의 계절성 질병을 예방하기 위해 적절한  휴식시간, 휴게시설 등을 제공한다.",
    isChecked: "",
  },
];
